export default __webpack_public_path__ + "static/media/guesser-box.7817510d.png";